import React, {useEffect} from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Route, Switch, withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';

import {Heading, LoadingIndicator} from '@edume/magnificent';

import * as managerInsightsActions from '../../state/managerInsights/managerInsightsActions';
import AssignedTraining from './AssignedTraining';
import ContentDetail from './ContentDetail';
import ErrorPage from './ErrorPage';
import Home from './Home';
import {OtpView} from './OtpView';
import TeamPerformance from './TeamPerformance';
import UserDetails from './UserDetails';

const mapStateToProps = (state, ownProps) => {
  const token = new URLSearchParams(ownProps.location.search).get('token');
  const {managerId, insightId} = ownProps.match.params;
  const {pathname} = ownProps.location;

  return {
    managerId,
    insightId,
    token,
    loading: state.managerInsights.get('loading'),
    loadingError: state.managerInsights.get('loadingError'),
    needToAuthenticate: state.managerInsights.get('needToAuthenticate'),
    pathname,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(managerInsightsActions, dispatch),
});

const ManagerInsightsRouter = ({
  getManagerInsights,
  loading,
  loadingError,
  needToAuthenticate,
  managerId,
  insightId,
  token,
  pathname,
}) => {
  useEffect(() => {
    if (!needToAuthenticate) {
      getManagerInsights({managerId, insightId, token});
    }
  }, [getManagerInsights, insightId, managerId, needToAuthenticate, token]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (loadingError) {
    return <ErrorPage showButton={false} title={'OtpLogin.Error.title'} />;
  } else if (loading) {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <LoadingIndicator indicator='hexagons' size={'large'} />
        <Heading
          as='h3'
          colour='textPrimary'
          size='sheep'
          textTransform='none'
          weight='semiBold'
        >
          Manager Insights Loading
        </Heading>
      </div>
    );
  } else if (needToAuthenticate) {
    return <OtpView managerId={managerId} insightId={insightId} />;
  }

  if (window.location.search.includes('token')) {
    window.history.replaceState({}, '', `${insightId}`);
  }

  return (
    <Switch>
      <Route exact path='/mi/:managerId/:insightId'>
        <Home />
      </Route>
      <Route exact path='/mi/:managerId/:insightId/team-performance'>
        <TeamPerformance />
      </Route>
      <Route exact path='/mi/:managerId/:insightId/assigned-training'>
        <AssignedTraining />
      </Route>
      <Route exact path='/mi/:managerId/:insightId/content-detail/:cid'>
        <ContentDetail />
      </Route>
      <Route exact path='/mi/:managerId/:insightId/user-detail/:uid'>
        <UserDetails />
      </Route>
    </Switch>
  );
};

ManagerInsightsRouter.propTypes = {
  managerId: PropTypes.string.isRequired,
  insightId: PropTypes.string.isRequired,
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  loadingError: PropTypes.bool.isRequired,
  needToAuthenticate: PropTypes.bool.isRequired,
  getManagerInsights: PropTypes.func.isRequired,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManagerInsightsRouter)
);
